import { Injectable } from '@angular/core';
import { PublicationLocalRepositoryService } from 'src/app/module/actions/data/repository/publication-local-repository.service';
import { PublicationRemoteRepositoryService } from 'src/app/module/actions/data/repository/publication-remote-repository.service';
import { z } from 'zod';
import { IPublication } from '../entity/publicationEntity';
import { Result } from 'neverthrow';
import { HttpErrorResponse } from '@angular/common/http';

const PublicationListByProcessIdOutPutSchema = z.object({
  processId: z.number(),
  documentId: z.number(),
  applicationId: z.number(),
  organicEntityId: z.number(),
  securityId: z.number(),
  userId: z.number(),
  dateIndex: z.string().datetime(),
  phase: z.number(),
  title: z.string(),
  message: z.string(),
  datePublication: z.string().datetime(),
  isExported: z.boolean(),
  sourceLocation: z.number(),
  sourceProcessId: z.number(),
  sourceDocumentId: z.number(),
}).array();

// Example usage:
export type PublicationListByProcessIdOutPut = z.infer<typeof PublicationListByProcessIdOutPutSchema>;


export interface IPublicationSyncResult {
  added: IPublication[];
  updated: IPublication[];
  remove: IPublication[];
}

@Injectable({
  providedIn: 'root'
})
export class PublicationListByProcessIdService {

  constructor(
    private remote: PublicationRemoteRepositoryService,
    private local: PublicationLocalRepositoryService,
  ) {}

  async execute(processId: number): Promise<Result<IPublicationSyncResult, HttpErrorResponse>> {
    const result = await this.remote.listByProcessId(processId);

    if(result.isOk()) {
      const publications = result.value.data.data || [];

      var localList = await this.local.find({processId: processId});

      if(localList.isOk()) {

        const localMap = new Map(
          localList.value.map(item => [item.documentId.toString(), item])
        );

        var serverMap = new Map(
          publications.map(item => [item.documentId.toString(), item])
        );

        const added = [];
        const updated = [];
        const remove = [];

        //console.log("local::", localList.value.length);
        //console.log("server::", publications.length);

        // detect added & updated
        for (const [id, serverItem] of serverMap) {
          if (!localMap.has(id)) {
            //console.log(serverMap.get(id), "addddddd");
            //console.log(localList, publications);
            added.push(serverMap.get(id));
          } else if (serverItem.datePublication !== localMap.get(id).datePublication) {
            updated.push(serverMap.get(id));
            //console.log('update');
          } else {
            //console.log('else');
            //console.log(localMap, serverMap);
          }
        }

        // detect removed
        for (const [id, localItem] of localMap) {
          if (!serverMap.has(id)) {
            remove.push(localMap.get(id));
          }
        }

        //console.log("update::", Object.keys(updated).length);
        //console.log("added::", added.length);
        //console.log("remove::", remove.length);

        // apply updates
        if (updated.length > 0) {
          await this.local.updateMany(Object.values(updated));
        }

        // apply removals
        for (const deletedItem of remove) {
          const findRequest = await this.local.findOne({
            documentId: deletedItem.documentId
          });
          if (findRequest.isOk()) {
            await this.local.delete(findRequest.value.documentId!);
          }
        }

        // apply inserts
        if (added.length > 0) {
          await this.local.insertMany(added);
        }

        return result.map(()=>({
          added,
          updated,
          remove
        }))
      }
    }

    return result.map(()=>({
      added: [],
      updated: [],
      remove: []
    }))

  }
}


